import * as Sentry from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN;
const environment = import.meta.env.MODE;
const tracesSampleRate = Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || "0");

export function initSentry() {
	if (!import.meta.env.PROD || !dsn) return;

	Sentry.init({
		dsn,
		environment,
		tracesSampleRate: Number.isFinite(tracesSampleRate) ? tracesSampleRate : 0,
		initialScope: {
			tags: {
				app: "web",
			},
		},
	});
}

export function captureRecoverableHydrationError(
	error: unknown,
	errorInfo?: { componentStack?: string },
) {
	Sentry.captureException(error, {
		level: "warning",
		tags: { category: "hydration_recoverable" },
		extra: {
			componentStack: errorInfo?.componentStack,
		},
	});
}
